import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_trash",
  "use": "svg_trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg_trash\"><path d=\"M20.25 6c0 1.243-3.694 2.25-8.25 2.25S3.75 7.243 3.75 6m16.5 0c0-1.243-3.694-2.25-8.25-2.25S3.75 4.757 3.75 6m16.5 0L18 19.5s-.75 1.5-6 1.5-6-1.5-6-1.5L3.75 6m10.125 6.375-3.75 3.75m0-3.75 3.75 3.75\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol